export default "__VITE_ASSET__QI6ZI6e3__"